import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
	isFrozenChartSnapshot,
	resolveDashboardChartBindingLabel,
	resolveDashboardChartRefreshLabel,
} from '../lib/statisticsChartRefreshMode';

const DashboardChartRefreshModeBadge = ({ snapshot, className }) => {
	const binding = useMemo(() => resolveDashboardChartBindingLabel(snapshot), [snapshot]);
	const refresh = useMemo(() => resolveDashboardChartRefreshLabel(snapshot), [snapshot]);
	const isFrozen = isFrozenChartSnapshot(snapshot);
	const groupLabel = `${binding.short} · ${refresh.short}`;

	return (
		<span
			className={classNames('dashboard-chart-refresh-mode-badge', className)}
			title={`${binding.title}；${refresh.title}`}
			aria-label={groupLabel}
		>
			<span className='dashboard-chart-refresh-mode-badge__binding'>{binding.short}</span>
			<span
				className={classNames('dashboard-chart-refresh-mode-badge__refresh', {
					'is-live': !isFrozen,
					'is-frozen': isFrozen,
				})}
			>
				<span className='dashboard-chart-refresh-mode-badge__dot' aria-hidden='true' />
				{refresh.short}
			</span>
		</span>
	);
};

DashboardChartRefreshModeBadge.propTypes = {
	snapshot: PropTypes.object,
	className: PropTypes.string,
};

export default memo(DashboardChartRefreshModeBadge);
